window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Components ================*/
$(document).ready(function() {    
  var $scrollTrigger = $('.scroll-trigger');
  var $slideshow = $('.js-slideshow');
  var $thumbs = $('.js-slideshow--thumbs');
  var $selectedSwatch = $('.product__swatch');  
  var $SizeGuideTrigger = $('.sizeGuideTrigger');  
  var $sizeGuidePopup = $('.size-guide__popup');
  var $wishlistBtn = $('.wishlist-add');

  //wishlistAction($wishlistBtn);
  closeContainer();
  cookiesToggle();
  animateSections();
  toggleSearch();  
  productQTY();
  accordion();
  accountWidget();
  scrollTo($scrollTrigger);
  slideshow($slideshow);
  galleryThumbnails($thumbs);
  selectedItem($selectedSwatch);
  popup($SizeGuideTrigger, $sizeGuidePopup);
  setUpVideoControls();
  trapSidecartFocus();
  sizeGuideTrapFocus();
  setSortingFilterOptions();
  setTimeout(removeAriaLabel, 1000);
  searchExpandedCheck();
  boostCustomSort();
  setTimeout(function() {
    // on load select first color by default
    $('.product-option.option--Color .product__swatch').trigger('click');
  }, 1000);
  
  $(window).on('resize scroll', function() {    
    animateSections();        
  });
});
  
// Close 
function closeContainer() {    
  $('body').on('click', '.js-close', function(e) {
    e.preventDefault();    
    $(this).closest('.js-close-parent').fadeOut();
  });
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function cookiesToggle() {        
  if(getCookie('CookiePopup') != 'closed') {
    $('.cookies-popup').show();    
  } 

  $('.cookies-popup .icon-close').on('click', function() {
      $('.skip-link').focus();
      $(this).closest('.cookies-popup').fadeOut();                        
      setCookie('CookiePopup', 'closed', 30);
  });        
}

// Is in viewport  
$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

// Scroll animation
function animateSections() {
  $('.scroll-animation').each(function() {
    if ($(this).isInViewport()) {
      $(this).addClass('active');        
    } else {
      $(this).removeClass('active');      
    }
  });
}

// Accordion Tabs
function accordion() {
  $('.tab-header').click(function(e) {                    
      $(this).closest('.tab').find('.tab-content').show();      
      $(this).closest('.tab').toggleClass('active');      
      $(this).closest('.tab').siblings().find('.tab-content').hide();
      $(this).closest('.tab').siblings().removeClass('active');                                                     
  });
}

// Product QTY
function productQTY() {
  var $qty = {
    input: '.js-qty__input',
    plus: '.js-qty--plus',
    minus: '.js-qty--minus',
  };

  $($qty.plus).on('click', function(e){        
      e.preventDefault();                
      var input = $(this).closest('.js-qty').find($qty.input);
      var currentVal = parseInt(input.val());        
      
      (!isNaN(currentVal)) ? input.val(currentVal + 1) : input.val(1);     
  });
  
  $($qty.minus).on('click', function(e) {    
      e.preventDefault();                
      var input = $(this).closest('.js-qty').find('.js-qty__input');
      var currentVal = parseInt(input.val());
      
      (!isNaN(currentVal) && currentVal > 1) ? input.val(currentVal - 1) : input.val(1);     
  });        
}

// Account widget
function accountWidget() {  
  var $body = 'body',
      $header = '#headerSection',
      $headerHeight = $($header).outerHeight();

  var $account = {
    container: '.account-widget',
    open: '#accountTrigger',
    close: '.overlay',          
    overlay: '.overlay',        
    loginTrigger: '.js-toggle--login',
    registerTrigger: '.js-toggle--register',
    recoverTrigger:  '.js-form-recover',
    loginForm: '.form--login',
    registerForm: '.form--register',
    recoverForm:  '.form--recover',
    closeBtn: '.close-account-widget',
    activeForm: 'form--login',

    widgetOpen: function() {      
      if(window.location.href.indexOf('account') > -1) {
        return;
      }

      $($account.container).css('display', 'block');
      $($body).addClass('account-widget-open');
      $($account.overlay).addClass('overlay--active');
      $($header).removeClass('transparent');
      $($header).addClass('js-sticky--showing');

      $($account.closeBtn).focus();
      const container = document.getElementsByClassName('account-widget')[0];
      const firstFocusableEl = container.getElementsByClassName('close-account-widget')[0]; 
      container.addEventListener('keydown', e => {
        const activeFormEl = document.getElementsByClassName(this.activeForm)[0];
        const focusableElArr = Array.from(activeFormEl.getElementsByTagName('button'))
        const lastFocusableEl = focusableElArr[focusableElArr.length - 1];
        if(e.target == firstFocusableEl && e.key == 'Tab' && e.shiftKey) {
          e.preventDefault();
          lastFocusableEl.focus();
        } else if(e.target == lastFocusableEl && e.key == 'Tab' && !e.shiftKey) {
          e.preventDefault();
          firstFocusableEl.focus();
        }
      });
    },
    widgetClose: function() {
      $($body).removeClass('account-widget-open');
      $($account.overlay).removeClass('overlay--active');
      $($account.container).css('display', 'none');
      $($account.open).focus();
    },
    toggleForms: function($trig, $form) {
      $($trig).closest('.form').hide();

      $('.account-widget').find($form).show();
      $account.activeForm = $form.substring(1);
      document.getElementsByClassName('close-account-widget')[0].focus();
    }
  };

  $($account.open).on('click', function() {    
    $account.widgetOpen();        
  }); 

  $($account.close).on('click', function() {
    $account.widgetClose();
  }); 

  $($account.closeBtn).on('click', function() {
    $account.widgetClose();
  }); 

  $().on('click', function() {
    $(this).closest('.form').slideUp();

    $('.account-widget').find('.form--register').fadeIn();
  });

  $().on('click', function() {
    $(this).closest('.form').hide();

    $('.account-widget').find('.form--login').show();
  });

  

  $($account.loginTrigger).on('click', function() {
    $account.toggleForms(this, $account.loginForm);
  });
  
  $($account.registerTrigger).on('click', function() {
    $account.toggleForms(this, $account.registerForm);
  });

  $($account.recoverTrigger).on('click', function() {
    $account.toggleForms(this, $account.recoverForm);
  });  
}
        

// Search
function toggleSearch() {
  $('.search-trigger').on('click', function(e) {
    e.preventDefault();
    var self = $(this);

    // add class .search-is-open
    $('body').addClass('search-is-open');
    $('.header__search').toggleClass('active');   
    $(this).closest('.header-section').find('.header__search #search').focus();

    $(this).attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true';
    });
  });

  // Close search on 'Esc' key press
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape') {
      // remove class .search-is-open
      $('body').removeClass('search-is-open');
      $('.header__search').removeClass('active');
      $('.search-trigger').attr('aria-expanded', 'false');
    }
  });
}


//Scroll To
function scrollTo($trigger) {
  $trigger.on('click', function () {    
    var target = $(this.getAttribute('href'));
    if( target.length ) {
      event.preventDefault();
      $('html, body').stop().animate({
          scrollTop: target.offset().top - 200
      }, 1000);
      target.focus();
    }
  });
}

// Slideshow
function slideshow($target) {            
  $target.each(function () {    
    if(!$(this).hasClass('slick-initialized')) {      
      var $self = $(this),
          $arrows = $(this).data('arrows'),
          $dots = $(this).data('dots'),
          $responsive = $(this).data('unslick'),
          $mobileOnly = $(this).data('mobile-only'),
          $centerMode = $(this).data('center-mode'),
          $centerPadding = $(this).data('center-padding'),
          $slidesDesktop = $(this).data('slides'),
          $slidesMobile = $(this).data('slides-mobile'),
          $asNavFor = $self.data('nav-for'),
          $isProductGallery = $(this).data('product-gallery'),
          $infinite = $(this).data('infinite');
          $arrowColor = $(this).data('arrow-color');

          
      
      if($arrows && $arrows !== undefined) {
        $arrows = true;
      } else {
        $arrows = false;
      }

      if($dots && $dots !== undefined) {
        $dots = true;
      } else {
        $dots = false;
      }

      if($slidesDesktop !== undefined) {
        $slidesDesktop = $self.data('slides');
      } else {
        $slidesDesktop = 1;
      }

      if($slidesMobile !== undefined) {
        $slidesMobile = $self.data('slides-mobile');
      } else {
        $slidesMobile = 1;
      }

      if($arrowColor !== undefined) {
        $arrowColor = $self.data('arrow-color');
      } else {
        $arrowColor = 'black';
      }

      if($centerMode && $centerMode !== undefined) {
        $centerMode = true;
      } else {
        $centerMode = false;
      }

      if($infinite !== undefined && $infinite == false) {
        $infinite = false;
      } else {
        $infinite = true;
      }

      if($isProductGallery !== undefined) {
        $nextArrow = `<button class="slick-next slick-arrow"><svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 0.980922L12.9556 7.5L1 14.0191L1 0.980922Z" stroke="black"/></svg></button>`;
        $prevArrow = `<button class="slick-prev slick-arrow"><svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 0.980922L1.04443 7.5L13 14.0191L13 0.980922Z" stroke="black"/></svg></button>`;
      } else {
        $nextArrow = `<button class="slick-next slick-arrow"><svg width="15" height="28" viewBox="0 0 15 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1.5L14 14L1.5 26.5" stroke="${$arrowColor}" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`;
        $prevArrow = `<button class="slick-prev slick-arrow"><svg width="15" height="28" viewBox="0 0 15 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1.5L14 14L1.5 26.5" stroke="${$arrowColor}" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/></svg></button>`;
      }
      
      if ($mobileOnly && $mobileOnly !== undefined) {
        if ($(window).width() < 769) {
          $(this).slick({          
            infinite: $infinite,          
            slidesToShow: $slidesMobile,
            slidesToScroll: 1,                              
            arrows: $arrows,
            centerMode: $centerMode,
            centerPadding: $centerPadding,
            dots: $dots,
            adaptiveHeight: true,
            mobileFirst: true,
            focusOnSelect: false,
            drag: true,
            nextArrow: $nextArrow,
            prevArrow: $prevArrow                      
          });
        }
      } else {
        $(this).slick({          
          infinite: $infinite,          
          slidesToShow: $slidesMobile,
          slidesToScroll: 1,                              
          arrows: $arrows,
          dots: $dots,
          adaptiveHeight: true,
          mobileFirst: true,
          focusOnSelect: false,
          drag: true,
          nextArrow: $nextArrow,
          prevArrow: $prevArrow, 
          responsive: [
            {
              breakpoint: 769,
              settings: {
                slidesToShow: $slidesDesktop,
                arrows: $arrows,              
                dots: $dots
              }
            }
          ]                                        
        });
      }

      $self.on('load', function() {
        $self.slick('refresh');
      });

      if($self.width() === 0) {
        $self.width('100vw');
      }

      if($responsive !== undefined && $responsive == 'mobile-up') {
        if($(window).width() > 769){
          $self.slick('unslick');   
        }      
      }       
      
      $(window).on('orientationchange resize', function () {   
        if($responsive !== undefined && $responsive == 'mobile-up') {
          if($(window).width() > 769){
            $self.slick('unslick');   
          }      
        }
      });      

      if ($self.hasClass('product-gallery')) {
        $self.eq(0).slick('refresh');
        $self.on('afterChange', function(event, slick, currentSlide, nextSlide) {
          $self.closest('.product-media').find('.product-gallery-paging__current').text(currentSlide+1);
        })
      }

      if ($self.hasClass('recommendations-product-grid')) {
        setTimeout(function() {
          $self.eq(0).slick('refresh');
        }, 1000)
      }
    }    
  });      
}

// Products Gallery Thumbnails  
function galleryThumbnails($target) {            
  $target.each(function () {
    if (!$(this).hasClass('slick-initialized')) {

      var $self = $(this),
          $arrows = $self.data('arrows'),                    
          $slides = $self.data('slides'),          
          $asNavFor = $self.data('nav-for');
          
      
      if($arrows && $arrows !== undefined) {
        $arrows = true;
      } else {
        $arrows = false;
      }      

      if($slides !== undefined) {
        $slides = $self.data('slides');
      } else {
        $slides = 1;
      }
      
      if($asNavFor && $asNavFor !== undefined) {
        $asNavFor = '.product-gallery';
      } else {
        $asNavFor = '';
      }

      $self.slick({                               
        slidesToShow: $slides,       
        slidesToScroll: 1,                                        
        arrows: $arrows,                              
        asNavFor: $asNavFor,                
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 769,
            settings: "unslick"
          }
        ]                           
      });

      $('.js-slideshow--thumbs .slick-current').attr('aria-current', 'true');

      // slick on click go to slide
      if($asNavFor && $asNavFor !== undefined) {
        $('.js-slideshow--thumbs .slick-slide').on('click', function(e) {
          $self.slick('slickGoTo', $(this).data('slick-index'));
          $('.product-gallery').slick('slickGoTo', $(this).data('slick-index'));
        })
      }

      $self.on('afterChange', function(event, slick, currentSlide, nextSlide) {
        $('.js-slideshow--thumbs .slick-slide').removeAttr('aria-current')
        $(this).find('.slick-current').attr('aria-current', 'true')
      });
    }
  });    
}

// Variant Change
function selectedItem($target){
  // var $selected = $('.selected');
  // var $label = $target.closest('.product-option').find('label');
  //$label.append($selected.data('value'));

  $target.each(function() {   
    var select = document.querySelector('.variantSelect');      
    var $selected = $('.variantSelect option:selected');      
    var $self = $(this);
    
    if($self.data('variant-id') == $selected.val()){
      $self.addClass('selected');
  
      // Start of the modified block
      if ($selected.data('option') && typeof $selected.data('option') === "string") {
        var size;
        if ($selected.data('option').includes('/')) {
          size = $selected.data('option').split('/')[0];
        } else {
          size = $selected.data('option');
        }
        $self.closest('fieldset').find('.current-variant-option').text(size);
      } else {
        console.warn('Expected a string, but received: ', $selected.data('option'));
      }
      // End of the modified block
    }
  
    $(this).on('keypress', function(e) {
      if (e.key == 'Enter') {
        e.preventDefault();
        return;
      }
    });

    $(this).on('click change', function() {      
      //$target.removeClass('selected');
      $(this).closest('fieldset').children('.product__swatch-option').children('.product__swatch').removeClass('selected');
      $(this).addClass('selected');    
      var atc = $(this).closest('form').find('[data-add-to-cart]');
      var bis = $(this).closest('form').find('#BIS_trigger');
      var preorder = $(this).closest('form').find('.preorder__line-items');
      var property = preorder.find('input');
      
      if (!$(this).hasClass('color-swatch')) {
        var value = $(this).data('value');
        $(this).closest('fieldset').find('.current-variant-option').text(value);
      }

      var variant = [];

      $('.selected').each(function(){
        variant.push($(this).data('value'));                
      });

      
      var temp = variant.join();
      variantCombined = temp.replace(',', ' / ');    
                      

      for( var _o=0; _o<select.options.length; _o++){
        var option	=	select.options[_o];
        
        if( option.getAttribute('data-option') === variantCombined){        
          select.selectedIndex	=	_o;    
                    
          if ($(this).closest('.product-wrapper').find('.product-gallery').hasClass('slick-initialized')) {
            if ($(this).attr('data-variant-img-index') != null) {
              var variantImgIndex = $(this).attr('data-variant-img-index');
              $(this).closest('.product-wrapper').find('.product-gallery').slick('slickGoTo', variantImgIndex - 1);
            }
          }

          document.querySelector('.limited-qty-message').textContent = `Only ${option.getAttribute('data-variant-qty')} left!`          
          
          if(option.getAttribute('data-variant-qty') > 0){
            // console.log('In stock', option.getAttribute('data-preorder'));
            property.attr('name', '');
            preorder.fadeOut();        
            bis.hide();
            atc.text('Add to Cart');
            atc.show();        
          } else {
            if(option.getAttribute('data-preorder') === 'true'){          
              // console.log('Preorder', option.getAttribute('data-preorder'));
              bis.hide();
              atc.show();
              atc.text('Pre Order');                                       
              property.attr('name', 'properties[Preorder]');     
              preorder.fadeIn();                                    
            } else {          
              // console.log('Notify');
              atc.hide();
              property.attr('name', '');
              preorder.fadeOut();                              
              bis.show();                      
            } 
          }
          break;
        }
      }           
    });                  
  });
}

// Size Guide Popup
function popup($trigger, $popup) {
  var $overlay = $('.overlay');

  $trigger.on('click', function(e) {
    e.preventDefault();
    $overlay.toggleClass('overlay--active size-guide-active');
    $popup.fadeToggle();
    $('.size-guide__popup .sizeGuideTrigger')[0].focus();
  });

  $('.size-guide__popup .sizeGuideTrigger').on('click', function(e) {
    e.preventDefault();     
    $overlay.removeClass('overlay--active size-guide-active');
    $popup.fadeOut();
    $('.buy-box__inner .sizeGuideTrigger')[0].focus();
  });

  $overlay.on('click', function(e) {     
    e.preventDefault();     
    $popup.fadeOut();
		setTimeout(()=>{
			$('.buy-box__inner .sizeGuideTrigger')[0].focus();
		}, 500)
  });
}

// $(function() {
//   $('body').on('keyup', function(e) {
//     if (e.key == '13' || e.key == 'Tab') {
//       console.log(e.target);
//     }
//   })
// });

function pauseVideo($videoContainer) {
  var iframe = $videoContainer.find( 'iframe')[0];

  if (iframe.contentWindow) {
    // Pause Youtube Videos
    if (iframe.src.startsWith("https://www.youtube.com")) {
      iframe.contentWindow.postMessage(
        '{"event":"command","func":"pauseVideo","args":""}',
        "*"
      );
    }

    // Pause Vimeo Videos
    if (iframe.src.startsWith("https://player.vimeo.com/")) {
      iframe.contentWindow.postMessage('{"method":"pause"}', "*");
    }
  } else {
    var video = $videoContainer.find( 'video')[0];
    video.trigger('pause');
  }
}

function playVideo($videoContainer) {
  var iframe = $videoContainer.find( 'iframe')[0];

  if (iframe.contentWindow) {
    // Pause Youtube Videos
    if (iframe.src.startsWith("https://www.youtube.com")) {
      iframe.contentWindow.postMessage(
        '{"event":"command","func":"playVideo","args":""}',
        "*"
      );
    }

    // Pause Vimeo Videos
    if (iframe.src.startsWith("https://player.vimeo.com/")) {
      iframe.contentWindow.postMessage('{"method":"play"}', "*");
    }
  } else {
    var video = $videoContainer.find( 'video')[0];
    video.trigger('play');
  }
}

function videoControls($btn, $videoContainer) {
  if ($btn.text() == 'Pause') {
    $btn.text('Play');
    pauseVideo($videoContainer);
  } else {
    $btn.text('Pause');
    playVideo($videoContainer);
  }
}

function setUpVideoControls() {
  var $videoContainer = $('.full-width-video-container');
  var $btn = $videoContainer.find( '.full-width-video__controls');

  if ($btn != undefined) {
    $btn.on('click', function() {
      videoControls($btn, $videoContainer)
    });
  }
}

function trapSidecartFocus() {
  var dialog = $('.sidecart');
  var firstFocusableElement = $('#closeSidecart')[0];
  var lastFocusableElement = $('.sidecart input[type=submit]')[0];
  var lastFocusableElement2 = $('.sidecart__empty a.btn')[0];

  dialog.on('keydown', function(e) {
    if (lastFocusableElement2 != undefined && $('.sidecart__empty').css('display') != 'none') {
      if(e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
        e.preventDefault();
        lastFocusableElement2.focus();
      } else if(e.target == lastFocusableElement2 && e.key == 'Tab' && !e.shiftKey) {
        e.preventDefault();
        firstFocusableElement.focus();
      }
    } else {
      if(e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
        e.preventDefault();
        lastFocusableElement.focus();
      } else if(e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
        e.preventDefault();
        firstFocusableElement.focus();
      }
    }
  });
}

function sizeGuideTrapFocus() {
  $(document).on('keydown', function(e) {
    if ($('.overlay').hasClass('size-guide-active')) {
      if (e.key == 'Tab' || e.key == 'Tab' && e.shiftKey) {
        e.preventDefault();
      }
    }
  });
}

function removeAriaLabel() {
  if ($('.wishlist-add').length) {
    $('.wishlist-add').removeAttr('aria-label');
  }
}

function wishlistAction(btn) {
  btn.on('click', function(e) {
    setTimeout(function(){
      $('#swym-component-container .swym-close-btn').focus();
      $('#swym-component-container .swym-close-btn')
    }, 1500);
  });
}

function setSortingFilterOptions() {
  setTimeout(function() {
    setAriaCurrent();
  }, 1000);

  $('body').on('click', '#boost-pfs-filter-tree .boost-pfs-filter-option-item', function(e) {
    if($(this).attr('aria-current') == 'false') {
      $(this).attr('aria-current', true);
      //$(this).find('.boost-pfs-filter-option-value').after('<span class="sr-only boost-is-selected">selected</span>')
    } else if (!$(this).attr('aria-current')) {
      $(this).attr('aria-current', true);
      // if ($(this).find('.boost-is-selected').length == 0) {
      //   $(this).find('.boost-pfs-filter-option-value').after('<span class="sr-only boost-is-selected">selected</span>')
      // }
    } else {
      $(this).attr('aria-current', false);
      // if ($(this).find('.boost-is-selected').length > 0) {
      //   $(this).find('.boost-is-selected').remove();
      // }
    }
  });
  

  $('body').on('click', '.boost-pfs-filter-button.boost-pfs-filter-clear', function(e) {
    setTimeout(function(e) {
      setAriaCurrent();
    }, 1000);
  });

  $('body').on('click', '.boost-pfs-filter-custom-sorting li', function(){
    var elemSort = $(this).find('a').data('sort');

    setTimeout(function(e) {
      $('.boost-pfs-filter-custom-sorting li a').each(function(e) {
        if ($(this).data('sort') == elemSort) {
          $(this).attr('aria-current', true);
        } else {
          $(this).attr('aria-current', false);
        }
      });
    }, 1000);
  });
}

function setAriaCurrent() {
  $('#boost-pfs-filter-tree .boost-pfs-filter-option-item').each(function(e) {
    if($(this).hasClass('selected')) {
      $(this).attr('aria-current', true);
    } else {
      $(this).attr('aria-current', false);
    }
  })

  $('.boost-pfs-filter-custom-sorting li a').each(function(e) {
    if($(this).hasClass('boost-pfs-filter-sort-item-active')) {
      $(this).attr('aria-current', true);
    } else {
      $(this).attr('aria-current', false);
    }
  });
}

$('body').on('click, keyup', function(e) {
  if (!$('#boost-pfs-search-box-1').is(':focus')) {
    $('#boost-pfs-search-box-1').attr('aria-expanded', false);
  }
});

function searchExpandedCheck() {
  $('body').on('click keyup', '#boost-pfs-search-box-1', function(){
    setExpandedSearch($(this));
  });
}

function setExpandedSearch(elem) {
  setTimeout(function() {
    if ($('.boost-pfs-search-suggestion-wrapper[data-search-box-id="boost-pfs-search-box-1"]').css('display') != 'none') {
      $(elem).attr('aria-expanded', true);
    } else {
      $(elem).attr('aria-expanded', false);
    }
  }, 500);
}

function boostCustomSort() {
  $('body').on('click', '#boost-custom-sort-btn', function(e) {
    if ($(this).attr('aria-expanded') == 'false') {
      $(this).attr('aria-expanded', true);
    } else {
      $(this).attr('aria-expanded', false);
    }
  });
}
$(document).ready(function() {  
  stickyHeader();  
  mobileMenu();
  mainMenu();
  watchKeyboardInput();
  mobileSearchLabel();
});

function stickyHeader() {
  var body = $('body'),
      header = $('#headerSection'),
      headerHeight = header.outerHeight(),
      topBar = $('.announcement-bar'),
      topBarHeight = topBar.outerHeight(),
      mainContent = $('#MainContent');    
      var headerTransparent = header.hasClass('transparent-header');

  if($(window).scrollTop() == 0){
    header.addClass('js-sticky--top');
  } else {
    header.addClass('js-sticky--scrolled');
    if (headerTransparent) {
      header.removeClass('transparent-header');
    }
  }
  mainContent.css('padding-top', headerHeight + topBarHeight);  

  $(window).on('scroll', function () {
    windowScrollTop = $(window).scrollTop();

    if (windowScrollTop > topBarHeight) {
      if(topBar.length > 0) {
        body.addClass('scrolled');
        header.removeClass('js-sticky--top');        
        header.addClass('js-sticky--scrolled');
        if (headerTransparent) {
          header.removeClass('transparent-header');
        }
      }      
    } else {
      if(topBar.length > 0) {
        body.removeClass('scrolled');
        header.addClass('js-sticky--top');     
        header.removeClass('js-sticky--scrolled');
        if (headerTransparent) {
          header.addClass('transparent-header');
        }       
      } 
    }
  });
}

function setAriaExpanded(elem) {
  if (elem.attr('aria-expanded') == 'false'){
    elem.attr('aria-expanded', 'true');
  } else {
    elem.attr('aria-expanded', 'false');
  }
}

function mobileMenu() {
  var mmenu = {
    trigger: '#mmenuTrigger',
    submenu: '.mobile-accordion__trigger',
    nav_icon: '.mobile-nav__icon',

    openMenu: function() {
      $('body').toggleClass('mobile-menu__open');      
      $(mmenu.submenu).find('a').removeAttr('href');

        $('.header-promo-slider-mobile').slick({
          infinite: true,
          arrows: false,
          draggable: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          autoplay: true,
          autoplaySpeed: 5000,
          pauseOnHover: true
        });

    },

    openSubmenu: function(target) {      
      $(target).closest('.site-nav__has-submenu').find('.site-nav__megamenu').toggle();
      $(target).find('.mobile-nav__icon').toggle();
      setAriaExpanded($(target).find('.mobile-accordion-header'));
    }
  };
  
  $(mmenu.trigger).on('click', function(e) {
    e.preventDefault();    
    mmenu.openMenu();
    $('#search').focus();
  });

  $(mmenu.submenu).on('click', function(e) {    
    mmenu.openSubmenu($(this));
  });

  $('body').on('click', '.boost-pfs-search-btn-close-suggestion', function(e) {
    $('.search-submit ').focus();
  });
}

function trapMobileMenuFocus(e) {
  if($('body').hasClass('mobile-menu__open') && e.target.id == 'mmenuTrigger') {
    if(e.key == 'Tab') {
      e.preventDefault();
      $('#search').focus();
    }
  }

  if($('body').hasClass('mobile-menu__open') && e.target.id == 'search') {
    if(e.shiftKey && e.key == 'Tab') {
      e.preventDefault();
      $('#mmenuTrigger').focus();
    }

    if(e.shiftKey && e.key == 'Tab' || e.key == 'Tab') {
      if ($('#search').val() == '') {
        $('.mobile-search-group label').addClass('search-label-normal');
        $('.mobile-search-group label').removeClass('search-label-top');
      } else {
        $('.mobile-search-group label').removeClass('search-label-normal');
        $('.mobile-search-group label').addClass('search-label-top');
      }
    }
  }

  if($('body').hasClass('mobile-menu__open') && e.target.classList.contains('boost-pfs-search-btn-close-suggestion')) {
    if(e.shiftKey) {
      e.preventDefault();
      $('#boost-pfs-search-box-mobile').focus();
    }
  }

  if($('body').hasClass('mobile-menu__open') && e.target.id == 'boost-pfs-search-box-mobile') {
    if(e.key == 'Tab') {
      e.preventDefault();
      $('.boost-pfs-search-btn-close-suggestion').focus();
    }
  }

  if ($('body').hasClass('mobile-menu__open') && e.key == 'Escape') {
    $('#mmenuTrigger').trigger('click');
    $('#mmenuTrigger').focus();
  }

  if($('body').hasClass('mobile-menu__open') && e.target.id != 'search') {
    if(e.shiftKey && e.key == 'Tab' || e.key == 'Tab') {
      if ($('#search').val() == '') {
        $('.mobile-search-group label').addClass('search-label-normal');
        $('.mobile-search-group label').removeClass('search-label-top');
      } else {
        $('.mobile-search-group label').removeClass('search-label-normal');
        $('.mobile-search-group label').addClass('search-label-top');
      }
    }
  }
}

function handleMenu(elem) {
  setAriaExpanded(elem);

  var submenu = elem.closest('.site-nav__has-submenu').find('.site-nav__megamenu');
  var submenuLinks = elem.closest('.site-nav__has-submenu').find('.level1');
  var submenuCTA = elem.closest('.site-nav__has-submenu').find('.megamenu-cta');

  if (submenu.hasClass('menu-is-active')) {
    submenu.removeClass('menu-is-active');
    submenuLinks.removeClass('show-element-flex');
    submenuCTA.removeClass('show-element');
  } else {
    submenu.addClass('menu-is-active');
    submenuLinks.addClass('show-element-flex');
    submenuCTA.addClass('show-element');
  }
}

function mainMenu() {
  var menuTrigger = $('.desktop-accordion__menu-trigger');

  menuTrigger.on('click', function(e) {
    handleMenu($(this));
  })
}

function watchKeyboardInput() {
  $('body').on('keydown', function(e){
    if (e.key == 'Tab' || e.shiftKey || e.key == 'Escape') {
      // current megamenu after reaching last element
      if (e.target.classList.contains('site-nav__megamenu-last-item')) {
        handleMenu($(e.target).closest('.site-nav__has-submenu').find('.desktop-accordion__menu-trigger'));
      }

      // when inside megamenu, if escape then close menu and focus button
      if ($(e.target).closest('div').hasClass('megamenu-cta') || $(e.target).closest('div').hasClass('site-nav__megamenu')) {
        if (e.key == 'Escape') {
          handleMenu($(e.target).closest('.site-nav__has-submenu').find('.desktop-accordion__menu-trigger'));
          $(e.target).closest('.site-nav__has-submenu').find('.desktop-accordion__menu-trigger').focus();

        }
      }

      trapMobileMenuFocus(e);
    }
  });
}

function mobileSearchLabel() {
  $('#search').on('change', function(e) {
    if ($(this).val() != '') {
      $(this).parent().find('label').addClass('search-label-top');
    }
  })
}
$(document).ready(function() {  
  CartJS.init(cartJson, {
    "moneyFormat": "${{amount}}"
  });
  
  // console.log('cart.js initialized', cartJson); // Debugging Only

  var $body = 'body',
      $header = '#headerSection',
      $headerHeight = $($header).outerHeight();      

  var $cart = {
    container: '.sidecart',
    open: '#cartTrigger',
    close: '.overlay, #closeSidecart, #contShoppingLink',          
    overlay: '.overlay',          
       
    ajaxCartOpen: function() {         
      $($cart.container).css('display', 'block');
      $($body).addClass('ajax-cart-open');
      $($cart.overlay).addClass('overlay--active');      
      $($header).addClass('js-sticky--hover');
      $('#closeSidecart').focus();
    },

    ajaxCartClose: function() {
      $($body).removeClass('ajax-cart-open');
      $($cart.overlay).removeClass('overlay--active');
      $($header).removeClass('js-sticky--hover');
      $($cart.container).css('display', 'none');
      $('.side-cart-button').focus();
    }       
  };  

  $(document).on('click', $cart.open, function(e) {    
    e.preventDefault();
    $cart.ajaxCartOpen();        		                         
  });

  $(document).on('click', $cart.close, function(e) {
    e.preventDefault();
    $cart.ajaxCartClose();		            
  });            

  function cardRedirect() {
    if (window.location.href.indexOf("#sidecart") > -1) {        
      $($body).addClass('ajax-cart-open');
      $($cart.overlay).addClass('overlay--active');
    }
  }                                  	      

  $(document).on('cart.requestComplete', function() {                 
    $cart.ajaxCartOpen();      
  });

  cardRedirect();
});  

rivets.formatters.currency = function(value) {
  return '$' + (value / 100).toFixed(2);
}

$('header .header-promo-slider').slick({
  infinite: true,
  arrows: false,
  draggable: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  autoplay: true,
  autoplaySpeed: 5000,
  pauseOnHover: true,
  lazyload: 'ondemand'
});


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggle('hidden');
    $('#CustomerLoginForm').toggle('hidden');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').toggle('hidden');
  }
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  /*********************************************
   * Lookbook JS
   ***********************************************/

  $('.section-lookbook .lookbook-slider-view').slick({
    infinite: true,
    arrows: true,
    draggable: true,
    slidesToShow: 1
  });

  $('.section-lookbook button.look-view').click(function(e) {
    $('.section-lookbook .lookbook-collection-wrapper').hide();
    $('.section-lookbook button.collection-view').removeClass('active')

    $(this).addClass('active');

    $('.section-lookbook .look-number-section').show();
    $('.section-lookbook .lookbook-slider-view').css('height','100%');
    $('.section-lookbook .lookbook-slider-view').css('overflow-y','visible');
  });

  $('.section-lookbook button.collection-view').click(function() {
    $('.section-lookbook .lookbook-collection-wrapper').show();
    $('.section-lookbook .lookbook-collection-view').css('display','flex');

    $('.section-lookbook .look-number-section').hide();
    $('.section-lookbook .lookbook-slider-view').css('height', '0px');
    $('.section-lookbook .lookbook-slider-view').css('overflow-y','hidden');

    $('.section-lookbook button.look-view').removeClass('active')

    $(this).addClass('active');
  });

  $('.section-lookbook .lookbook-slider-view').on('afterChange', function(event, slick, currentSlide, nextSlide) {
    $('.section-lookbook .look-number-section .look-num').text(currentSlide+1);
  });
});